module.exports = __webpack_public_path__ + "img/house_plan03.31c5c0c0.svg";